﻿import {CreateOrSelectResidencyModel} from "../components/CreateOrSelectResidencyComponent";
import {ZoneId} from "../nominalTypes/ZoneId";
import {Residencies} from "../Residencies";
import {AllPermitsResult} from "../types/AllPermitsResult";
import {FormPermit} from "../types/arguments/FormPermit";

export default function updatePermitBranch(permit: FormPermit, result: CreateOrSelectResidencyModel, permits: AllPermitsResult): void {
	if (permit.branch == null) permit.branch = {zoneId: "" as ZoneId};
	if (result.residencyId === "create") {
		permit.branch.zoneId = result.arguments.zoneId;
	} else {
		permit.branch.zoneId = Residencies.get(permits, result.residencyId).zoneId!;
	}
}
